import type { RowData, Table } from "@tanstack/react-table";
import type { ComponentProps } from "./index";

export default function useFixedLayout<D extends RowData>(
  table: Table<D>,
): Partial<ComponentProps<D>> {
  const tableMinWidth = table.getTotalSize();
  return {
    colgroupElement: (
      <colgroup>
        {table.getVisibleLeafColumns().map((column) => {
          const rawWidth = column.getSize();
          const { size, minSize, maxSize } = column.columnDef;
          const isAuto = size === -1;
          const width = isAuto ? "auto" : rawWidth;
          const minWidth = isAuto ? minSize : undefined;
          const maxWidth =
            !isAuto || !maxSize || maxSize > 10000 ? undefined : maxSize;
          return (
            <col
              key={column.id}
              span={1}
              width={width}
              style={{ width, minWidth, maxWidth }}
            />
          );
        })}
      </colgroup>
    ),
    tableProps: {
      style: { minWidth: tableMinWidth, tableLayout: "fixed" },
    },
  };
}
